import { createSlice } from "@reduxjs/toolkit";

import { submitIncident, getIncidents, fetchIncidentDashboard } from "./incidentActions.js";

const initialState = {
  dashboard: { data: null, loading: false, error: null, requestId: null },
  mutationVersion: 0,
  incidents: [],
  currentIncident: null,

  loading: false,
  listLoading: false,

  error: null,
  listError: null,

  success: false,
};

const incidentSlice = createSlice({
  name: "incident",

  initialState,

  reducers: {
    clearIncidentErrors: (state) => {
      state.error = null;
      state.listError = null;
    },

    resetIncident: (state) => {
      state.currentIncident = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },

    clearIncidentSuccess: (state) => {
      state.success = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchIncidentDashboard.pending, (state, action) => {
        state.dashboard = { data: null, loading: true, error: null, requestId: action.meta.requestId };
      })
      .addCase(fetchIncidentDashboard.fulfilled, (state, action) => {
        if (state.dashboard.requestId !== action.meta.requestId) return;
        state.dashboard.data = action.payload;
        state.dashboard.loading = false;
        state.dashboard.requestId = null;
      })
      .addCase(fetchIncidentDashboard.rejected, (state, action) => {
        if (state.dashboard.requestId !== action.meta.requestId) return;
        state.dashboard.loading = false;
        state.dashboard.error = action.meta.aborted ? null : action.payload || 'Unable to load incident dashboard';
        state.dashboard.requestId = null;
      })

      // ============================================================
      // GET INCIDENTS
      // ============================================================

      .addCase(getIncidents.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })

      .addCase(getIncidents.fulfilled, (state, action) => {
        state.listLoading = false;
        state.incidents = action.payload.data;
      })

      .addCase(getIncidents.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || "Failed to fetch incidents";
      })

      // ============================================================
      // CREATE / UPDATE INCIDENT
      // ============================================================

      .addCase(submitIncident.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })

      .addCase(submitIncident.fulfilled, (state, action) => {
        state.mutationVersion += 1;
        state.loading = false;
        state.success = true;
        state.currentIncident = action.payload.data;

        // Optional: immediately update the list
        const incident = action.payload.data;

        const index = state.incidents.findIndex(
          (item) => item.id === incident.id,
        );

        if (index !== -1) {
          state.incidents[index] = incident;
        } else {
          state.incidents.unshift(incident);
        }
      })

      .addCase(submitIncident.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Failed to submit incident";
      });
  },
});

export const { clearIncidentErrors, resetIncident, clearIncidentSuccess } =
  incidentSlice.actions;

export default incidentSlice.reducer;
